import React, { Component } from "react";
import { connect } from 'react-redux';
import {WebFormTemplateMappedNames, WebFormViewReport, WebFormViewReportSubmit, WebFormSearchCompleted, resetsearchData, closeModalPopUp} from './WebFormAction';
import {TokenValidation, InventoryUserMappedAction} from '../Dashboard/UserActions';
import WebFormCreate from './WebFormCreate';
import WebFormSearch from './WebFormSearch';
import ShowModalPopUp from '../ShowModalPopUp';
import _ from 'lodash';
import {Tabs, Tab} from 'react-bootstrap';

class WebFormReport extends Component {
  constructor(props){
    super(props)
    this.state={
 
    }
  }
  componentWillMount(){
    this.props.TokenValidation()
    this.props.actioninventoryUserMapped()
    //this.props.formNamesMapped(this.props.loginAction.userName)
  }
  loadTabContent = (prop) => {
    this.setState({key:prop})
  } 
  ScreensComp = () =>{        
    const{reports, formNameMapped, inventory, loginAction, searchReport, inventoryMapped} = this.props;  
    const{key} = this.state
    if(!_.isEmpty(loginAction)){
    let moduleAccess = _.find(loginAction.modulescreens, {"moduleUId": "WEB_FORM_REPORT_SUBMISSION"})
    let returnObj =[]
    _.map(moduleAccess.screens, (obj) =>{ 
        if(obj.screenUId === "WEB_FORMS"){ 
          returnObj.push(<Tab eventKey="WEB_FORMS" title="CREATE" key={1}>
             <WebFormCreate function={this.props} reports={reports} loginAction={loginAction}
             inventory={inventory}
                webFormNames={formNameMapped}/>
         </Tab>)}
        if(obj.screenUId === "WEB_FORMS_SEARCH"){ 
          returnObj.push(<Tab eventKey="WEB_FORMS_SEARCH" title="SEARCH" key={2}>
          <WebFormSearch function={this.props} reports={reports} loginAction={loginAction} inventory={inventoryMapped}
              searchReport={searchReport} />        
       </Tab>)}
    })
    returnObj =	_.sortBy(returnObj, ['key'])
   return (<Tabs defaultActiveKey={moduleAccess.screens[0].screenUId} transition={false} activeKey={key ? key : returnObj[0].props.eventKey} unmountOnExit={true}
   id="noanim-tab-example" onSelect={(eventKey)=>this.loadTabContent(eventKey)}>
   {returnObj}</Tabs>)
    }
     
  } 
 
  render(){ 
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }
    return(
      <div className={(style) ? 'user' : "userSmall"}>
      {(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} 
        falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
        {this.ScreensComp()}
      </div>)
  }
}
function mapStateToProps(state){
  return{
    inventoryMapped: state.UserReducer.inventoryMapped,
    formNameMapped : state.WebFormReducer.formNameMapped,
    reports : state.WebFormReducer.report,
    showModalLogin: state.UserReducer.showModalLogin,    
    showerror:  state.WebFormReducer.showerror, 
    loginAction: state.LoginReducer.loginAction,
    errmessage:  state.WebFormReducer.errmessage,
    searchReport : state.WebFormReducer.searchReport,
    inventory: state.UserReducer.inventoryMapped, 
    size: state.UserReducer.large,  
    
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  formNamesMapped: (a) =>dispatch(WebFormTemplateMappedNames(a)) ,
  viewReport: (a, b) =>dispatch(WebFormViewReport(a, b)),
  viewReportSubmit: (a) =>dispatch(WebFormViewReportSubmit(a)), 
  closeModalPopUp:  (a) =>dispatch(closeModalPopUp(a)),
  TokenValidation : (a) => dispatch(TokenValidation(a)),
  WebFormSearchCompleted : (a) => dispatch(WebFormSearchCompleted(a)),     
  resetsearchData: () => dispatch(resetsearchData()) 
})

export default connect(mapStateToProps, mapDispatchToProps)(WebFormReport);